import Input from "../../../common/Input";

const Compliances = ({
  formik,
  isEdit,
  handleEditIconClick,
  handleBlur,
  editingField,
  isDisabled,
}) => {
  const { values, handleChange, touched, errors, setFieldTouched } = formik;
  return (
    <div className="mb-3">
      <h2 className="text-black-lose text-[13px] font-medium mb-2">
        Compliances
      </h2>
      <div className="grid grid-cols-10 gap-[8px]">
        <div className="col-span-10 md:col-span-5 lg:col-span-4 xl:col-span-3">
          <Input
            placeholder="Enter"
            inputBox="mb-0"
            id="compliances.gstNumber"
            type="text"
            labelName="GST Number"
            labelClassName="block text-primary-400 text-[13px] leading-[20px]"
            className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
            name="compliances.gstNumber"
            value={values?.compliances?.gstNumber}
            onChange={(e) => {
              handleChange(e);
              setFieldTouched("compliances.gstNumber", true, false); // Mark the field as touched
            }}
            isError={
              touched?.compliances?.gstNumber &&
              Boolean(errors?.compliances?.gstNumber)
            }
            errorMessage={errors?.compliances?.gstNumber}
            disabled={isDisabled && editingField !== "compliances.gstNumber"}
            showEditIcon={isEdit}
            onBlur={() =>
              handleBlur ? handleBlur("compliances.gstNumber") : ""
            }
            onEditClick={() => handleEditIconClick("compliances.gstNumber")}
            disabledClass="bg-primary-50 border-primary-50 "
          />
        </div>
        <div className="col-span-10 md:col-span-5 lg:col-span-4 xl:col-span-3">
          <Input
            placeholder="Enter"
            inputBox="mb-0"
            type="text"
            labelName="Registration Number*"
            labelClassName="block text-primary-400 text-[13px] leading-[20px]"
            className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
            name="compliances.registrationNumber"
            id="compliances.registrationNumber"
            value={values?.compliances?.registrationNumber}
            onChange={handleChange}
            isError={
              touched?.compliances?.registrationNumber &&
              Boolean(errors?.compliances?.registrationNumber)
            }
            errorMessage={errors?.compliances?.registrationNumber}
            disabled={
              isDisabled && editingField !== "compliances.registrationNumber"
            }
            showEditIcon={isEdit}
            onBlur={() =>
              handleBlur ? handleBlur("compliances.registrationNumber") : ""
            }
            onEditClick={() =>
              handleEditIconClick("compliances.registrationNumber")
            }
            disabledClass="bg-primary-50 border-primary-50 "
          />
        </div>
      </div>
    </div>
  );
};

export default Compliances;
